import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseDocumentEffects, baseDocumentReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('documents', baseDocumentReducer.BaseDocumentsReducer),
    EffectsModule.forFeature([baseDocumentEffects.BaseDocumentsEffects]),
  ],
})
export class BaseDocumentsStoreModule {}
